import React from 'react';
import './styles.scss';

import Spinner from 'reactstrap/es/Spinner';

const MainSpinner = () => {
  return (
    <div className="styled-spinner2">
      <Spinner className="spinner-wrapper2" />
    </div>
  );
};

export default MainSpinner;
